import type {
  ScaleLinear,
  ScaleLogarithmic,
  ScaleSymLog,
  ScaleTime,
} from 'd3-scale';

import { VisxGridPoint } from '../GridLine.js';

/**
 * Determines if a line (zero line) should be highlighted.
 * @param from - The starting pixel point you should consider as a reference to where the line is placed.
 * @param to - The ending pixel point you should consider as a reference to where the line is placed.
 * @param scale - The scale to properly detect if this a zero line
 * @returns a boolean that decides if should be highlighted or not
 */
export const shouldHighlightZeroLine = (
  from: VisxGridPoint,
  to: VisxGridPoint,
  scale:
    | ScaleLinear<number, number>
    | ScaleLogarithmic<number, number>
    | ScaleSymLog<number, number>
    | ScaleTime<number, number>,
): boolean => {
  const [scaleRangeStart] = scale.range();
  const zeroLineValue = scale(0);
  const isHorizontal = from.y === to.y;
  const isVertical = from.x === to.x;

  if (isHorizontal || isVertical) {
    const axisValue = isHorizontal ? from.y : from.x;
    const isZeroLine = axisValue === zeroLineValue;
    const isAxisLine = axisValue === scaleRangeStart;

    return isZeroLine && !isAxisLine;
  }

  return false;
};
